module.exports = __webpack_public_path__ + "static/media/impacto_economico_do_alojamento_local_no_algarve.e5bcb3a6.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/docs/impacto_economico_do_alojamento_local_no_algarve.pdf
// module id = 412
// module chunks = 0